import React from 'react';

const SeasonPayouts = ({ payoutData }) => {
    const total = payoutData.reduce((acc, cur) => {
        return acc + cur.payout;
    }, 0);
    return (
        <div id="Payouts" className="PayoutsContainer">
            <h4>Payouts</h4>
            <table className="table table-dark table-striped">
                <tbody>
                    {payoutData.map(payout => {
                        return (
                            <tr key={`${payout.type}-${payout.manager}`}>
                                <td>{payout.type}</td>
                                <td>{payout.payout}</td>
                                <td>{`${payout.manager || ''}${payout.winner ? `: ${payout.winner}` : ''}`}</td>
                            </tr>
                        )
                    })}
                    <tr key='totals'>
                        <td>Totals</td>
                        <td>{total}</td>
                        <td>Buy in: {total / 12}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default SeasonPayouts;